import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import {Animated, KeyboardAvoidingView} from 'react-native';

export const ModalMask = styled.View`
  background-color: rgba(0, 0, 0, 0.7);
  flex: 1;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const ModalContainer = styled.View`
  flex-grow: 1;
  justify-content: flex-end;
`;

export const ModalContent = styled.View.attrs(() => ({
  style: {
    shadowColor: '#000',
    shadowOffset: {width: 0, height: -2},
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
}))`
  background-color: ${({theme}) => theme.colors.background};
  padding-bottom: ${RFValue(12)}px;
  border-top-left-radius: 26px;
  border-top-right-radius: 26px;
`;

export const Handle = styled.View`
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background-color: ${({theme}) => theme.colors.placeholder};
  align-self: center;
  margin-top: 12px;
  margin-bottom: 4px;
`;

export const ModalContentContainer = styled(KeyboardAvoidingView)`
  width: 100%;
  flex: 1;
`;

export const SlideshowBackground = styled(Animated.View)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;
